import http from "../http-common";

class ServiceDataService {
  // Get all services (active only)
  getAll() {
    return http.get('/services');
  }

  // Get all services including inactive (for admin management)
  getAllWithInactive() {
    return http.get('/services-all');
  }

  // Get service by ID
  get(id) {
    return http.get(`/services/${id}`);
  }

  // Create new service
  create(data) {
    return http.post('/services', data);
  }

  // Update service
  update(id, data) {
    return http.put(`/services/${id}`, data);
  }

  // Delete service
  delete(id) {
    return http.delete(`/services/${id}`);
  }
}

export default new ServiceDataService();
